<!--
  功能：功能描述 产品编码
  作者：jiangyongqiang
  邮箱：missfoxw@163.com
  时间：2023年11月17日 13:54:58
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="sp-link-noline mb-1 fs-14" @click="goPage(product)">#{{ product.productInfo.code }}</div>
</template>

<script setup>
const { $Utils } = useNuxtApp()
const props = defineProps({
  product: {
    type: Object,
    default: () => {
      return {
        productInfo: {
          code: '',
          nameEn: ''
        }
      }
    }
  }
})

const goPage = product => {
  const nameEn = $Utils.replaceSpacesWithDash(product.productInfo.nameEn)

  navigateTo(`/product/${product.productInfo.code}_${nameEn}`)
}
</script>

<style scoped></style>
